import { useSubscription } from '@apollo/client/react';
import React, { createContext, useReducer, useRef, useContext, useMemo, useEffect } from 'react'
import { MESSAGE_NOTIFICATION_DISPATCH_SUBSCRIPTION } from '../graphql/subscriptions/messageNotificationDispatch';
import { useAuth } from './AuthContext';
import useErrorToast from '../hooks/useErrorToast';
import { toast } from '../hooks/use-toast';
import { ShowMessageToast } from '../components/chat/ShowMessageToast';
import { manageRoom, newMessageAddCount, roomClear, setActiveRoom, setActiveRoomDriverInfo, setInActiveRoom } from './actions';
import { getUserId } from '../utils';
import { useRouter } from 'next/router';

const ChatContext = createContext();

const chatReducer = (state, action) => {
  switch (action.type) {
    case 'ROOM_SUCCESS':
      return { ...state, rooms: { ...state.rooms, data: action.payload } }
    case 'ROOM_LOAD_MORE_SUCCESS':
      return { ...state, rooms: { data: [...state.rooms.data, ...action.payload], activeRoom: state.rooms.activeRoom } }
    case 'ROOM_CLEAR':
      return { ...state, rooms: { data: [], activeRoom: state.rooms.activeRoom } }
    case 'DRIVER_STATUS_UPDATED':
      return {
        ...state,
        rooms: {
          ...state.rooms,
          data: state.rooms.data.map(room => {
            return room.channel.driver.id === action.payload.id ?
              {
                ...room,
                channel: {
                  ...room.channel,
                  driver: {
                    ...room.channel.driver,
                    is_online: action.payload.is_online
                  }
                }
              } : room
          })
        }
      }
    case 'ROOM_CHANGE_ON_MESSAGE': {
      if (state.messages.data.length > 0 && state.messages.data[0].roomId === action.payload.roomId) {
        state.messages.data.push(action.payload)
      }
      let updatedRoomData = []
      if (state.rooms.data.length > 0) {
        updatedRoomData = [
          state.rooms.data.find(room => room.id == action.payload.roomId),
          ...state.rooms.data.filter(room => room.id != action.payload.roomId)
        ].map(room => {
          if (room.id == action.payload.roomId) {
            room.text = action.payload.text
            // room.unread = room.unread + 1
            return room
          }
          return room
        })
      }
      const latestState = {
        ...state,
        rooms: {
          data: updatedRoomData,
          activeRoom: state.rooms.activeRoom
        },
        messages: {
          ...state.messages,
          data: state.messages.data
        }
      }

      // if (action.payload.text) {
      //   latestState.rooms.data[0].text = action.payload.text
      // }
      if (action.payload.roomId != state.rooms.activeRoom) {
        latestState.rooms.data[0].unread = latestState.rooms.data[0].unread + 1
      }
      if (action.payload.roomId == state.rooms.activeRoom) {
        latestState.rooms.data[0].unread = 0
      }

      return latestState
    }
    case 'SEND_NEW_MESSAGE':
      return {
        ...state,
        messages: { ...state.messages, data: action.payload.chat_room_id === state?.rooms?.activeRoom ? [...state.messages.data, action.payload] : state.messages.data },
        rooms: {
          ...state.rooms,
          data: [
            state.rooms.data.find(room => room.channel.id == action.payload.chat_room_id),
            ...state.rooms.data.filter(room => room.channel.id != action.payload.chat_room_id)
          ].map(room => {
            if (room.channel.id == action.payload.chat_room_id) {
              return {
                ...room,
                channel: {
                  ...room.channel,
                  total_unread_messages: action?.payload?.type === "driver" ? room.channel.total_unread_messages + 1 : room.channel.total_unread_messages,
                },
                last_message: {
                  ...room.last_message,
                  ...action.payload,
                }

              }
            }
            return room
          })
        }
      }
    case 'MESSAGE_UPDATE': {
      if (state.rooms.activeRoom === action.payload.chat_room_id) {
        return {
          ...state,
          messages: {
            ...state.messages,
            data: state.messages.data.map(message => {
              if (message.id == action.payload.id) {
                return { ...message, ...action.payload, }
              }
              return message
            })
          },
          rooms: {
            ...state.rooms,
            data: state.rooms.data.map(room => {
              if (room.channel.id == action.payload.chat_room_id && room.last_message.id === action.payload.id) {
                return {
                  ...room,
                  last_message: {
                    ...room.last_message,
                    ...action.payload,
                  }
                }
              }
              return room
            })
          }
        }
      } else {
        return {
          ...state,
          rooms: {
            ...state.rooms,
            data: state.rooms.data.map(room => {
              if (room.channel.id == action.payload.chat_room_id && room.last_message.id === action.payload.id) {
                return {
                  ...room,
                  last_message: {
                    ...room.last_message,
                    ...action.payload,
                  }
                }
              }
              return room
            })
          }
        }
      }
    }
    case 'ROOM_MESSAGE_UNREAD':
      return {
        ...state,
        rooms: {
          data: state.rooms.data.map(room => {
            if (room.id == action.payload) {
              room.unread = 0
              return room
            }
            return room
          }),
          activeRoom: state.rooms.activeRoom
        }
      }
    case 'ROOM_ERROR':
      return { ...state, rooms: { error: action.error } }
    case 'MESSAGE_SUCCESS':
      return { ...state, messages: { ...state.messages, data: action.payload } }
    case 'MESSAGE_LOAD_MORE':
      return { ...state, messages: { ...state.messages, data: [...action.payload, ...state.messages.data] } }
    case 'MESSAGE_ERROR':
      return { ...state, messages: { ...state.messages, error: action.error } }
    case 'MANAGE_ROOM': {
      if (state?.rooms?.data?.length > 0) {
        const newMessage = action.payload;
        const roomFound = state.rooms.data.find(room => room.channel.id === newMessage.channel_id)

        if (!roomFound) {
          const newRoom = {
            "channel": {
              "id": newMessage.channel_id,
              "total_unread_messages": 1,
              "driver": {
                "id": newMessage.driver.id,
                "first_name": newMessage.driver.first_name,
                "last_name": newMessage.driver.last_name,
                "profile_picture": newMessage.driver.profile_picture,
                "is_online": true
              },
              "employee": {
                "id": null,
                "first_name": null,
                "last_name": null,
                "profile_picture": null
              },
              "created_at": new Date().toISOString()
            },
            "last_message": {
              "chat_room_id": newMessage.channel_id,
              "user_id": newMessage.driver.id,
              "type": "driver",
              "message": newMessage.message_type === "text" ? newMessage.message : null,
              "is_seen": false,
              "attachment_path": newMessage.message_type !== "text" ? newMessage.message : null,
              "message_type": newMessage.message_type,
              "message_status": "delivered",
              "created_at": new Date().toISOString()
            }
          }
          return {
            ...state,
            rooms: {
              ...state.rooms,
              data: [newRoom, ...state.rooms.data],
            }
          }
        }

        return state
      }
      return state
    }
    case 'SET_ACTIVE_ROOM':
      return {
        ...state,
        rooms: {
          data: state.rooms.data.map(room => {
            if (room.channel.id == action.payload && room.last_message.type === "driver" && !room.last_message.is_seen) {
              return {
                ...room,
                last_message: {
                  ...room.last_message,
                  is_seen: true,
                  message_status: "read",
                }
              }
            }
            return room
          }),
          activeRoom: action.payload
        }
      }
    case 'SET_ACTIVE_ROOM_DRIVER_INFO':
      return {
        ...state,
        messages: {
          ...state.messages,
          activeRoomDriverInfo: action.payload
        }
      }
    case 'SET_INACTIVE_ROOM':
      return {
        ...state,
        rooms: {
          data: state.rooms.data,
          activeRoom: ""
        },
        messages: {
          ...state.messages,
          room_id: "",
          data: [],
          activeRoomDriverInfo: null
        },
      }
    case 'SET_TOTAL_UNREAD':
      return { ...state, totalUnread: action.payload }
    case 'NEW_MESSAGE_ADD_COUNT':
      return { ...state, totalUnread: action.payload, showAnimation: true }
    case 'REMOVE_TOTAL_UNREAD':
      return { ...state, totalUnread: state.totalUnread - 1 }
    case 'UPDATE_CHANNEL_UNREAD_COUNT':
      return {
        ...state,
        rooms: {
          ...state.rooms,
          data: state.rooms.data.map(room => {
            if (room.channel.id === action.payload.channelId) {
              return {
                ...room,
                channel: {
                  ...room.channel,
                  total_unread_messages: room.channel.total_unread_messages - action.payload.totalReadCount,
                },
              }
            }
            return room
          }),
        },
      }
    case 'READ_MULTIPLE_MESSAGES':
      return {
        ...state,
        messages: {
          ...state.messages,
          data: state.messages.data.map(message => {
            if (action.payload.messageIds.includes(message.id)) {
              return { ...message, is_seen: true, message_status: "read" }
            }
            return message
          })
        },
      }
    case 'ANIMATION_HIDE':
      return { ...state, showAnimation: false }
    default:
      return state
  }
}

export const ChatProvider = ({ children }) => {
  const lastChatNotifRef = useRef({ key: null, time: 0 });
  const router = useRouter();
  const { user: { user } } = useAuth();
  let userId = getUserId(user);

  const [state, dispatch] = useReducer(chatReducer, {
    rooms: {
      data: [],
      activeRoom: "",
    },
    messages: {
      activeRoomDriverInfo: null,
      room_id: "",
      data: []
    },
    totalUnread: 0,
    showAnimation: false
  })

  const contextValue = useMemo(() => ({ state, dispatch }), [state]);

  useEffect(() => {
    if (userId) {
      dispatch(roomClear());
      dispatch(setInActiveRoom());
    }
  }, [userId]);

  const { error: messageNotificationDispatchError } = useSubscription(MESSAGE_NOTIFICATION_DISPATCH_SUBSCRIPTION, {
    variables: { companyId: `${userId}` },
    skip: !userId,
    onData: ({ data }) => {
      const messageNotification = data.data.messageNotificationDispatch;

      dispatch(manageRoom(messageNotification))

      if (data?.data?.messageNotificationDispatch?.totalUnreadCount > 0) {
        if (state.rooms.activeRoom !== messageNotification.channel_id) {
          // The same message notification can be delivered twice (e.g. a
          // duplicate subscription after a WS reconnect), which double-fired the
          // toast + sound. Skip an identical notification seen within 3s.
          const _dedupKey = `${messageNotification.channel_id}-${messageNotification.driver?.id}-${messageNotification.message}-${messageNotification.message_type}`;
          const _now = Date.now();
          if (lastChatNotifRef.current.key === _dedupKey && _now - lastChatNotifRef.current.time < 3000) {
            return;
          }
          lastChatNotifRef.current = { key: _dedupKey, time: _now };
          try {
            const audio = typeof window !== "undefined" ? new Audio() : "";
            audio.src = "assets/notification/chat_notification.mp3";
            audio.play();
          } catch (error) {
            console.error("Error playing audio:", error);
          }
          dispatch(newMessageAddCount(messageNotification.totalUnreadCount));
          toast({
            id: _dedupKey,
            description: (
              <ShowMessageToast
                messageData={data}
                onOpenChat={(channelId, driverInfo) => {
                  router.push(`/chat`);
                  dispatch(setActiveRoom(channelId))
                  dispatch(setActiveRoomDriverInfo(driverInfo))
                }}
              />
            ),
          });
        }
      }
    },
  });

  useErrorToast([
    messageNotificationDispatchError
  ]);

  return (
    <ChatContext.Provider value={contextValue}>
      {children}
    </ChatContext.Provider>
  )
}

export const useChat = () => useContext(ChatContext)